import { localize } from '@/utils/i18n'
import { text } from '../locales'
import { computed } from 'vue'

export const useComputedData = (params, props) => {
    const successMessage = computed(() => {
        const successMessage = localize({
            ru: `На почтовый адрес <z-link href="mailto:${params.value.email}" :underlined="false">${params.value.email}</z-link> было отправлено письмо с подтверждением.<br>В дальнейшем вы сможете менять настройки подписки на странице <z-link :underlined="false" href="./?state=requestEdit">Управление подпиской.</z-link>`,
            en: `A&nbsp;confirmation email has been sent to&nbsp;<z-link href="mailto:${params.value.email}" :underlined="false">${params.value.email}</z-link>`,
            cn: `A&nbsp;confirmation email has been sent to&nbsp;<z-link href="mailto:${params.value.email}" :underlined="false">${params.value.email}</z-link>`
        })

        switch (params.value.state) {
        case 'requestEdit':
        case 'requestUnsubscribe':
            return successMessage
        case 'edit':
            return text.editSuccessTitle
        case 'unsubscribe':
            return text.unsubscribeTitle
        default:
            return successMessage
        }
    })

    const successDescription = computed(() => {
        const editDescription = localize({
            ru: `Вы можете менять настройки подписки на странице <z-link href="./?id=${props.subscriber?.id}&confirm-code=${props.subscriber['confirm-code']}&email=${props.subscriber?.email}&state=edit">Управление подпиской.</z-link>`,
            en: `You can change the subscription settings on&nbsp;the <z-link href="./?id=${props.subscriber?.id}&confirm-code=${props.subscriber['confirm-code']}&email=${props.subscriber?.email}&state=edit">Manage Subscription page.</z-link>`,
            cn: `You can change the subscription settings on&nbsp;the <z-link href="./?id=${props.subscriber?.id}&confirm-code=${props.subscriber['confirm-code']}&email=${props.subscriber?.email}&state=edit">Manage Subscription page.</z-link>`
        })

        switch (params.value.state) {
        case 'requestEdit':
            return ''
        case 'requestUnsubscribe':
            return ''
        case 'edit':
            return editDescription
        case 'unsubscribe':
            return text.unsubscribeDescription
        default:
            return ''
        }
    })

    const policyText = computed(() => {
        return localize({
            ru: `Я&nbsp;даю согласие на&nbsp;обработку своих персональных данных. С&nbsp;Политикой ООО &laquo;ИНК&raquo; в&nbsp;области <z-link href="/personal-data-policy/">обработки персональных данных</z-link> и&nbsp;текстом <z-link href="/personal-data-policy/">согласия на&nbsp;обработку персональных данных</z-link> ознакомлен, возражений не&nbsp;имею.`,
            en: '',
            cn: ''
        })
    })

    const submitBtnText = computed(() => params.value.state === 'subscribe' ? text.subscribe : text.change)

    const formTitle = computed(() => {
        if (params.value.state === 'subscribe') return text.subscribeTitle
        return text.editTitle
    })

    const formDescription = computed(() => {
        const subscribeDescription = localize({
            ru: 'Если вы&nbsp;уже подписаны и&nbsp;хотите изменить настройки подписки&nbsp;&mdash; все нужное есть на&nbsp;странице <z-link :underlined="false" href="./?state=requestEdit">&laquo;Управление подпиской&raquo;.</z-link>',
            en: 'If&nbsp;you are already subscribed and want to&nbsp;change your subscription settings, everything you need is&nbsp;there on&nbsp;the <z-link :underlined="false" href="./?state=requestEdit">Manage Subscription page.</z-link>',
            cn: 'If&nbsp;you are already subscribed and want to&nbsp;change your subscription settings, everything you need is&nbsp;there on&nbsp;the <z-link :underlined="false" href="./?state=requestEdit">Manage Subscription page.</z-link>'
        })
        const requestEditDescription = localize({
            ru: 'Если вы&nbsp;еще не&nbsp;подписаны и&nbsp;хотите изменить параметры подписки, <z-link :underlined="false" href="./?state=subscribe">то&nbsp;подпишитесь</z-link>.',
            en: 'If&nbsp;you have not yet subscribed and would like to&nbsp;change your subscription settings, then <z-link :underlined="false" href="./?state=subscribe"> subscribe</z-link>.',
            cn: 'If&nbsp;you have not yet subscribed and would like to&nbsp;change your subscription settings, then <z-link :underlined="false" href="./?state=subscribe"> subscribe</z-link>.'
        })

        switch (params.value.state){
            case 'requestEdit':
                return requestEditDescription
            case 'subscribe':
                return subscribeDescription
            default:
                return ''
        }

    })

    const errorsMap = computed(() => {
        const alreadySubribeError = computed(() => {
            return localize({
                ru: `Этот адрес уже подписан на рассылку. Перейдите на страницу <z-link theme="dark" href="./?state=requestEdit&email=${params.value.email}">Управление подпиской</z-link> для изменения настроек.`,
                en: `This address is already subscribed to the mailing list. Go to the <z-link theme="dark" href="./?state=requestEdit&email=${params.value.email}">Subscription Management</z-link> page to change the settings.`,
                cn: `This address is already subscribed to the mailing list. Go to the <z-link theme="dark" href="./?state=requestEdit&email=${params.value.email}">Subscription Management</z-link> page to change the settings.`
            })
        })

        return ({
            'email-13': alreadySubribeError.value,
            'email-12': localize({
                ru: 'Данный email не подписан на рассылку',
                en: 'This email is not subscribed to the newsletter',
                cn: 'This email is not subscribed to the newsletter'
            }),
            'email-14': localize({
                ru: 'Данный email не подтвержден, ',
                en: 'This email has not been verified, ',
                cn: 'This email has not been verified, '
            })
        })
    })


    return {
        successMessage,
        successDescription,
        policyText,
        submitBtnText,
        formTitle,
        formDescription,
        errorsMap
    }
}
